import React, { useEffect } from "react";
import Slider from "react-slick";
const Fest = () => {

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1
        }
      }
    ]
  };
  return (
    <div>
     
      <section className="slider-section">
        <Slider {...settings}>
 
            <div className='manor-_blk'>
              <img src="/festslide1.png" />
            </div> 
            <div className='manor-_blk'>
              <img src="/festslide2.png" />
            </div> 
            <div className='manor-_blk'>
              <img src="/festslide3.png" />
            </div> 
            <div className='manor-_blk'>
              <img src="/festslide4.png" />
            </div> 
            <div className='manor-_blk'>
              <img src="/festslide5.png" />
            </div>  
        </Slider>
        <div class="button"><a href="#"><button>View Programs</button></a></div>
      </section>
    </div>
  );
};

export default Fest;
